<script>
  import Tabs from "../../../components/Tabs.svelte";
  import CallsLogs from "./CallsLogs.svelte";
  import CallRecordings from "./CallRecordings.svelte";

  let mode = 'calls'
  const setMode = m => mode = m
</script>

<div id="call-history">
  <div class="row d-flex tabing-row">
    <Tabs flex {mode} {setMode} label='calls' cls='sq-button'>
      <p class="text-center w-100 font-700 padding-bottom-10" class:active={mode=='calls'}><a href="#">Calls</a></p>
    </Tabs>
    <Tabs flex {mode} {setMode} label='recordings' cls='sq-button'>
      <p class="text-center w-100 font-700 padding-bottom-10" class:active={mode=='recordings'}>Calls Recordings</p>
    </Tabs>
  </div>

  {#if mode == 'calls'}
    <CallsLogs />
  {:else if mode == 'recordings'}
    <CallRecordings />
  {/if}
</div>

<style lang="scss">
  #call-history {
    .tabing-row p a {
      color: #A7B4BE;
    }
    .tabing-row p.active a {
      color: #0E99D2!important;
      font-weight: 600;
    }
    .tabing-row p.active {
      border-bottom: 2px solid #0E99D2;
    }
    .tabing-row p{
      color: #A7B4BE;
      font-weight: 500;
    }
  }
</style>
